import React, { useState } from "react";

export default function WatchPlaylistPicker({
  seasonData,
  onSelectPlaylist,
  selectedPlaylistId,
}) {
  const [isOpen, setIsOpen] = useState(false);

  function toggleOptionList() {
    if (isOpen) {
      setIsOpen(false);
      document.querySelector(".watch-playlist-picker__option-list").classList.remove('.hidden');
    } else {
      setIsOpen(true);
      document.querySelector(".watch-playlist-picker__option-list").classList.add('.hidden');
    }
  }

  function choosePlaylistItem(e) {
    onSelectPlaylist(e);
    toggleOptionList();
  }

  return (
    <div className="watch-playlist-picker">
      <div className="watch-playlist-picker__selector-wrapper" onClick={toggleOptionList}>
        <div className="watch-playlist-picker__selector">
          {seasonData.find((season) => season.id == selectedPlaylistId).attributes.name}
        </div>
        <ul
          className={
            isOpen ? "watch-playlist-picker__option-list" : "watch-playlist-picker__option-list hidden"
          }
        >
          {seasonData.map((season) => {
            return (
              <li key={season.id} value={season.id} onClick={choosePlaylistItem}
                className={
                  selectedPlaylistId == season.id ?
                    "watch-playlist-picker__option watch-playlist-picker__option--selected"
                    : "watch-playlist-picker__option"
                }
              >
                {season.attributes.name}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
